import {Context, createContext} from 'solid-js'
import {IconProviderBehavior} from './IconProvider'

export const IconContext: Context<IconProviderBehavior> = createContext({
    get: (icon: string) => ({}),
})
